/* __next_internal_client_entry_do_not_use__ Input auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./index.module.scss";
import { MINI_STAKING_AMOUNT, useStore } from "../../StoreProvider";
import BigNumber from "bignumber.js";
import { formatDecimal } from "../../utils";
const Input = function() {
    let { className } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = useTranslations();
    const { amountValue, changeAmountValue, accountData } = useStore();
    const containerRef = useRef();
    const handleChange = (event)=>{
        changeAmountValue(event.target.value);
    };
    const handleMax = useCallback(()=>{
        changeAmountValue(formatDecimal(BigNumber(accountData.userRemainingStakeAmount).isLessThan(accountData.userTokenAmount) ? accountData.userRemainingStakeAmount : accountData.userTokenAmount));
    }, [
        accountData,
        changeAmountValue
    ]);
    const handleBlur = useCallback(()=>{
        // 防止空字符串变成0
        if (amountValue !== "") {
            // 科学计算法
            changeAmountValue(formatDecimal(amountValue.toString()));
        }
    }, [
        changeAmountValue,
        amountValue
    ]);
    const handleFocus = useCallback(()=>{
        const dom = document.getElementById("bgbStakingContainer");
        // containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(()=>{
            console.log("dom.scrollHeight", dom.scrollHeight);
            dom.scroll(0, dom.scrollHeight);
        }, 400);
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        ref: containerRef,
        className: classNames("relative p3 rounded-2.5 h-48px bg-[var(--bg-0)]", className),
        children: [
            /*#__PURE__*/ _jsx("input", {
                value: amountValue,
                onChange: handleChange,
                type: "text",
                onFocus: handleFocus,
                onBlur: handleBlur,
                inputMode: "decimal",
                autoCorrect: "off",
                autoComplete: "off",
                autoCapitalize: "off",
                placeholder: "".concat(t("least"), " ").concat(MINI_STAKING_AMOUNT),
                className: "".concat(styles.input, " text-[var(--text-7)] w-full bg-[var(--bg-0)] text-16px w-40 focus:outline-none"),
                style: {
                    // 防止 iOS 缩放
                    WebkitTextSizeAdjust: "100%",
                    // 禁用长按菜单
                    WebkitTouchCallout: "none"
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "absolute w-40px h-20px flex items-center justify-center right-3 top-50% translate-y-[-50%]",
                onClick: handleMax,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "bg-[var(--primary)] rounded-1 absolute w-full h-full opacity-12"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-[var(--primary)] font-700 text-14px",
                        children: "Max"
                    })
                ]
            })
        ]
    });
};
export { Input };
